/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Side_WordsInputs */

const en_us2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dominant side left right handed`)
};

const pt_br2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lado dominante canhoto destro`)
};

const es_419_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lado dominante zurdo diestro izquierdo derecho`)
};

const pt_pt2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lado dominante canhoto destro esquerdino`)
};

const fr_fr2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cote dominant gaucher droitier gauche droite`)
};

const de_de2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dominant seite links rechts linkshänder rechtshänder`)
};

const it_it2_search_field_side_words = /** @type {(inputs: Search_Field_Side_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lato dominante mancino destrorso sinistra destra`)
};

/**
* | output |
* | --- |
* | "dominant side left right handed" |
*
* @param {Search_Field_Side_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_side_words = /** @type {((inputs?: Search_Field_Side_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Side_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_side_words(inputs)
	if (locale === "es-419") return es_419_search_field_side_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_side_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_side_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_side_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_side_words(inputs)
	return en_us2_search_field_side_words(inputs)
});
export { search_field_side_words as "search.field_side_words" }